import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getBankAccountsInput,
  getBankAccountInput,
  BankAccountLiteModel,
  BankAccountModel,
} from './model';

export function useGetBankAccounts(
  input?: getBankAccountsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<BankAccountLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<BankAccountLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getBankAccounts', input?.params],
      () =>
        QueryFetchFunction({
          url: 'bank-accounts',
          params: input?.params,
        }),
      options,
    ),
    BankAccountLiteModel,
  );
}

export function useGetBankAccount(
  input?: getBankAccountInput,
  options?: UseQueryOptions<ApiResult<BankAccountModel>, ApiError>,
): UseQueryResult<ApiResult<BankAccountModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getBankAccount', input?.id],
      () => QueryFetchFunction({ url: `bank-accounts/${input?.id}` }),
      options,
    ),
    BankAccountModel,
  );
}

export function getBankAccountsKey(input?: getBankAccountsInput) {
  return ['getBankAccounts', input?.params].filter(Boolean);
}

export function getBankAccountKey(input?: getBankAccountInput) {
  return ['getBankAccount', input?.id].filter(Boolean);
}
